import { TrophyIcon } from '@heroicons/react/24/outline';
export const AwardIcon = TrophyIcon;
